import { Component, OnInit } from '@angular/core';
import { NavigationService } from '../../services/navigation/navigation.service';
import { GlobalStoreService } from '../../services/global-store/global-store.service';
import { ErreurMappingService } from '../../services/errors/erreur-mapping.service';
import { GestionTitreService } from 'src/app/services/navigation/gestion-titre.service';
import { TypeChangementEnum } from '../../constantes/type-changement.enum';
import { TypeErreurEnum } from '../../constantes/type-erreur.enum';
import { CybermetrieCoordonneesService } from '../../services/cybermetrie/cybermetrie.service';
import { CybermetrieEnum } from '../../models/cybermetrie/cybermetrie.enum';
import { CoordonneesClient } from 'src/app/api/model/coordonnees-client.model';
import { Telephones, TelephonesTypeTelephoneEnum } from 'src/app/api/model/telephones.model';
import { CompteDetention } from 'src/app/api/model/compte-detention.model';
import { ConfigurationService } from '../../services/configuration/configuration.service';
import { GabaritService } from 'src/app/services/gabarit/gabarit.service';
import { ConfigMeta } from 'src/app/models/meta';

const URL_ADP = 'oel-adp-url';
const DOMAINE_VISA = 'visa';

@Component({
  selector: 'app-accueil-hogan',
  templateUrl: './accueil-hogan.component.html',
  styleUrls: ['./accueil-hogan.component.scss'],
  standalone: false,
})
export class AccueilHoganComponent implements OnInit {
  isAppMobile: boolean;
  isWebMobile: boolean;
  typeChangementEnum = TypeChangementEnum;
  titre: string = 'caad.titre';
  typeMessageErreur: string;
  horsEcranNumeroTelephone = '';
  etatModification: string = null;
  etatErreur: string = null;
  isFlowModificationAdresse: boolean = false;
  isMembre: boolean = false;
  coordonneesClient: CoordonneesClient;

  telephonePrincipal: string;
  telephoneSecondaire: string;
  telephoneEmployeur: string;

  constructor(
    public readonly navigationService: NavigationService,
    private readonly erreurMappingCanadaForm: ErreurMappingService,
    protected globalStoreService: GlobalStoreService,
    protected gestionTitreService: GestionTitreService,
    protected cybermetrieCoordonneesService: CybermetrieCoordonneesService,
    protected readonly configService: ConfigurationService,
    private readonly gabaritService: GabaritService
  ) {}

  ngOnInit(): void {
    this.isAppMobile = this.gabaritService.isAppMobile();
    this.isWebMobile = this.gabaritService.isWebMobile();
    this.isMembre =
      DOMAINE_VISA !== this.configService.getValueOrBlank(configuration.ConfigMeta.OEL_DOMAINE)?.toLowerCase();
    this.globalStoreService.getCoordonneesClient$().subscribe((data) => {
      if (data) {
        this.coordonneesClient = data;
        if (data.telephones) {
          this.telephonePrincipal = this.getNumeroTelephone(TelephonesTypeTelephoneEnum.PRINCIPAL, data.telephones);
          this.telephoneSecondaire = this.getNumeroTelephone(TelephonesTypeTelephoneEnum.SECONDAIRE, data.telephones);
          this.telephoneEmployeur = this.getNumeroTelephone(TelephonesTypeTelephoneEnum.EMPLOYEUR, data.telephones);
        }
        this.horsEcranNumeroTelephone =
          this.telephoneSecondaire || this.telephoneEmployeur ? 'numerosTelephones' : 'numeroTelephone';
        this.gestionTitreService.addTitreOnglet(
          this.coordonneesClient.comptesDetention.length > 1
            ? 'caad.titreOnglet.ACCUEIL_MULTICARTE'
            : 'caad.titreOnglet.ACCUEIL'
        );
        if (this.coordonneesClient.comptesDetention.length > 1) {
          this.titre = 'caad.titreMulticarte';
        }
      }
    });
    this.isFlowModificationAdresse = this.globalStoreService.getFlowChangement() === TypeChangementEnum.COORDONNEES;
    this.gestionErreur();
    this.etatModification = this.globalStoreService.getEtatModification();
    this.typeMessageErreur = this.isAppMobile ? 'messageMobile' : 'message';
    this.globalStoreService.saveUpdateDataForm(null);
    this.globalStoreService.saveErrorsForm([]);
    this.erreurMappingCanadaForm.resetFormsError();
  }

  allerVersPrecedent(): void {
    return this.configService.isConfigEqualValue(ConfigMeta.OEL_CAAD_BANCAIRE_ACTIF, 'true')
      ? this.navigationService.naviguerVersCoordonnees()
      : this.navigationService.naviguerVersUrlExterne(
          `${this.configService.getValueOrBlank(URL_ADP)}/dossier-personnel/liste-adresses`
        );
  }

  estBancaireActif(): boolean {
    return this.configService.isConfigEqualValue(ConfigMeta.OEL_CAAD_BANCAIRE_ACTIF, 'true');
  }

  private getNumeroTelephone(type: TelephonesTypeTelephoneEnum, telephones: Telephones[]) {
    return telephones?.find((tel) => tel.typeTelephone === type && tel.numeroTelephone)?.numeroTelephone;
  }

  private gestionErreur(): void {
    this.globalStoreService.getEtatErreur().subscribe((erreur) => {
      //CAAD.999999, CAAD.503300, CAAD.500100, CAAD.400100, CAAD.500200, CAAD.400200, CAAD.400009
      this.etatErreur = 'indisponible';
      const errCode = erreur?.error?.errors?.[0]?.code;
      if (errCode) {
        if (
          errCode === TypeErreurEnum.NON_MEMBRE ||
          errCode === TypeErreurEnum.ADRESSE_DIFFERENTE ||
          errCode === TypeErreurEnum.STATUT_RISQUE ||
          errCode === TypeErreurEnum.NUMEROCOMPTE ||
          errCode === TypeErreurEnum.ADRESSES_COMPTES_DIFFERENTES ||
          errCode === TypeErreurEnum.SWITCH_MULTICOMPTE_CODETENTION ||
          errCode === TypeErreurEnum.COMPTE_TRANSFERT ||
          errCode === TypeErreurEnum.MIX_COMPTES_AFF_PRI_ORD
        ) {
          this.etatErreur = 'acces';
        } else if (
          errCode === TypeErreurEnum.PAS_DE_CARTE ||
          errCode === TypeErreurEnum.AFFAIRE_PRIVATIF ||
          errCode === TypeErreurEnum.PLUSIEURS_CARTES
        ) {
          this.etatErreur = 'carte';
        }
        this.gestionTitreService.addTitreOnglet('caad.titreOnglet.erreur');
      }
    });
  }

  private redirection(type: TypeChangementEnum, compteDetention?: CompteDetention): void {
    switch (type) {
      case TypeChangementEnum.COORDONNEES:
        this.cybermetrieCoordonneesService.envoyerEvenementPersonnalise(
          CybermetrieEnum.CATEGORIE_GESTION_CARTE,
          CybermetrieEnum.ACTION_CLIC,
          CybermetrieEnum.LABEL_BOUTON_MODIFIER_ADRESSE
        );
        this.navigationService.naviguerVersModificationCredit();
        this.cybermetrieCoordonneesService.envoyerEvenementPersonnalise(
          CybermetrieEnum.CATEGORIE_TRANSACTION,
          CybermetrieEnum.ACTION_DEBUTE,
          CybermetrieEnum.LABEL_MODIFIER_ADRESSE
        );
        break;
      case TypeChangementEnum.TELEPHONE:
        this.cybermetrieCoordonneesService.envoyerEvenementPersonnalise(
          CybermetrieEnum.CATEGORIE_GESTION_CARTE,
          CybermetrieEnum.ACTION_CLIC,
          CybermetrieEnum.LABEL_BOUTON_MODIFIER_TELEPHONE
        );
        this.navigationService.naviguerVersModificationTelephoneCredit();
        this.cybermetrieCoordonneesService.envoyerEvenementPersonnalise(
          CybermetrieEnum.CATEGORIE_TRANSACTION,
          CybermetrieEnum.ACTION_DEBUTE,
          CybermetrieEnum.LABEL_MODIFIER_TELEPHONE
        );
        break;
      case TypeChangementEnum.COURRIEL:
        this.cybermetrieCoordonneesService.envoyerEvenementPersonnalise(
          CybermetrieEnum.CATEGORIE_GESTION_CARTE,
          CybermetrieEnum.ACTION_CLIC,
          CybermetrieEnum.LABEL_BOUTON_MODIFIER_COURRIEL
        );
        this.navigationService.naviguerVersModificationCourrielCredit(compteDetention);
        this.cybermetrieCoordonneesService.envoyerEvenementPersonnalise(
          CybermetrieEnum.CATEGORIE_TRANSACTION,
          CybermetrieEnum.ACTION_DEBUTE,
          CybermetrieEnum.LABEL_MODIFIER_COURRIEL
        );
        break;
    }
  }
}
